/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Nie sprzedawaj ani nie udostępniaj moich danych osobowych",
      "Bumble Date",
      "Nasze aplikacje",
      "O nas",
      "Praca",
      "Kontakt",
      "Inwestorzy",
      "Sklep",
      "Firma",
      "Pobierz aplikację",
      "Dostępność w Bumble",
      "Zasady użytkowania",
      "Zarządzaj plikami cookie",
      "Ustawa o współczesnym niewolnictwie",
      "Powiadomienie w przypadku gromadzenia danych",
      "Polityka prywatności",
      "Regulamin",
      "Kwestie prawne",
      "Polityka prywatności konsumenckich danych zdrowotnych (Waszyngton)",
      "Zeskanuj kod QR, aby pobrać aplikację Bumble",
      "Rozwiąż umowy tutaj",
      "Zamknij menu",
      "Otwórz menu",
      "Wybór języków",
      "Stopka",
      "Dostępność w Bumble",
      "Apple oraz logo Apple są znakami towarowymi Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Praca",
      "Google Play to znak towarowy Google LLC.",
      "Zasady użytkowania",
      "Inwestorzy",
      "Zarządzaj plikami cookie",
      "Oświadczenie na mocy brytyjskiej Ustawy o współczesnym niewolnictwie",
      "Powiadomienie w przypadku gromadzenia danych",
      "Polityka Prywatności",
      "Sezonowe porady randkowe",
      "Regulamin",
      "Aplikacja",
      "Polityka prywatności danych Washington Consumer Health",
      "O nas",
      "Ambasadorzy marki",
      "Nawiązuj nowe znajomości i znajdź swoją społeczność.",
      "Stwórz siatkę kontaktów zawodowych i rozwijaj swoją karierę.",
      "Znajdź kogoś do związku, czegoś nieformalnego lub czegoś pomiędzy.",
      "Blog",
      "Dowiedz się więcej",
      "Podbij świat z Trybem podróży",
      "Date",
      "Funkcje",
      "Compliments",
      "Nie szczędź komplementów, aby wyróżnić się z tłumu.",
      "Znajdź",
      "Spersonalizowana strona, która wyróżnia najbardziej kompatybilne z Tobą osoby. Codziennie ktoś nowy.",
      "Tryb Incognito",
      "Użyj Trybu Incognito, aby ukryć swój profil przed szefową, krewnymi lub byłymi.",
      "Szybkie dopasowanie",
      "Udało Ci się kogoś poznać podczas eventu na żywo Bumble? Kontynuujcie znajomość w apce.",
      "Opening Moves",
      "Wybierz Opening Moves, aby to Twoje dopasowanie zaczęło rozmowę zamiast Ciebie.",
      "Tryb uśpienia",
      "Zrób sobie przerwę od randek z Trybem uśpienia. Kiedy znowu poczujesz gotowość do randek, wiesz, gdzie nas znaleźć.",
      "SuperSwipe",
      "Odpowiada Ci ten profil? Użyj SuperSwipe i daj tej osobie znać.",
      "Tryb podróży",
      "Przejdź w Tryb podróży i znajdź nie tylko przekąski w sklepie bezcłowym, ale i dopasowania – w dowolnym miejscu na świecie.",
      "Czat video",
      "Skorzystaj z czatów video i rozmów audio, aby sprawdzić, czy to już czas na spotkanie twarzą w twarz.",
      "Apka internetowa",
      "Skorzystaj z Bumble w przeglądarce.",
      "Pobierz aplikację Bumble",
      "BFF",
      "Bezpieczeństwo",
      "Historie",
      "Pomoc",
      "Sklep",
      "Główna",
      "Nie szczędź komplementów, aby wyróżnić się z tłumu.",
      "Compliments",
      "Funkcje przeznaczone do tworzenia przestrzeni na autentyczne, pełne szacunku i wartościowe relacje.",
      "Ukryj swój profil przed szefową, krewnymi lub swoimi byłymi.",
      "Tryb Incognito",
      "Zrób sobie przerwę od randek z Trybem uśpienia.",
      "Tryb uśpienia",
      "Ktoś wpadł Ci w oko? Daj tej osobie znać.",
      "SuperSwipe",
      "Poznaj Date",
      "Znajdź swoją ulubioną bezcłową przekąskę i swoje dopasowanie – gdziekolwiek jesteś.",
      "Tryb podróży",
      "Prawie jak na żywo, ale bez wychodzenia z domu.",
      "Rozmowy video",
      "Nasi liderzy i liderki promują wartości Bumble w swoich społecznościach na terenie całego kraju.",
      "Liderzy i liderki społeczności",
      "Funkcje zaprojektowane po to, aby pomóc Ci znaleźć „swoich” ludzi i łączyć się z nimi dzięki wspólnym zainteresowaniom.",
      "Zorganizuj spotkanie grupowe lub odkryj lokalne wydarzenia w Twojej okolicy.",
      "Plans",
      "Poznaj BFF",
      "Wszystkie wskazówki i inspiracje, jakich potrzebujesz, aby znaleźć miłość i przyjaźń.",
      "Porady i historie, które pomogą Ci budować takie przyjaźnie, na jakich Ci zależy.",
      "Centrum znajomości",
      "Od Tokio po Toronto: przekonaj się, jak Bumble pomaga znaleźć miłość na całym świecie.",
      "Historie miłosne",
      "Zaplanuj idealną randkę. Niezależnie od tego kiedy, gdzie lub z kim się umawiasz.",
      "Sezonowe porady randkowe",
      "Poznaj nasze Historie",
      "Przeczytaj więcej",
      "Bumble na {{social_network}}",
      "Kontakt",
      "Zaloguj się",
      "(opens in new window)",
      "FAQ",
      "Cookie Policy",
      "Bumble - Blog",
      "Praca",
      "Czat",
      "Miasta",
      "Zarządzaj cookies",
      "Prawa autorskie © 2006 – obecnie. Bumble. Wszelkie prawa zastrzeżone.",
      "Raport z Randkowania z pewnością siebie",
      "Apple i logo Apple są znakami towarowymi firmy Apple Inc.{{__EOL__}}Google Play jest znakiem towarowym firmy Google LLC.",
      "Pobierz",
      "Facebook",
      "Obserwuj nas",
      "Centrum pomocy",
      "Instagram",
      "Język",
      "LinkedIn",
      "Bumble to część Bumble Inc.",
      "Polityka prywatności",
      "Safety Centre",
      "Mapa witryny",
      "Oświadczenie w spr. Ustawy o Współczesnym Niewolnictwie",
      "Regulamin",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "few": [
                  "dni",
                  "dni",
                  "dniom",
                  "dni",
                  "dniach",
                  "dniami",
                  "dni"
            ],
            "many": [
                  "dni",
                  "dni",
                  "dniom",
                  "dni",
                  "dniach",
                  "dniami",
                  "dni"
            ],
            "plural": [
                  "dni",
                  "dni",
                  "dni",
                  "dni",
                  "dni",
                  "dni",
                  "dni"
            ],
            "singular": [
                  "dzień",
                  "dnia",
                  "dniowi",
                  "dzień",
                  "dniu",
                  "dniem",
                  "dzień"
            ]
      },
      "hour": {
            "few": [
                  "godziny",
                  "godzin",
                  "godzinom",
                  "godziny",
                  "godzinach",
                  "godzinami",
                  "godziny"
            ],
            "many": [
                  "godzin",
                  "godzin",
                  "godzinom",
                  "godzin",
                  "godzinach",
                  "godzinami",
                  "godzin"
            ],
            "plural": [
                  "godzin",
                  "godzin",
                  "godzin",
                  "godzin",
                  "godzin",
                  "godzin",
                  "godzin"
            ],
            "singular": [
                  "godzina",
                  "godziny",
                  "godzinie",
                  "godzinę",
                  "godzinie",
                  "godziną",
                  "godzina"
            ]
      },
      "minute": {
            "few": [
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min."
            ],
            "many": [
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min."
            ],
            "plural": [
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min."
            ],
            "singular": [
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min.",
                  "min."
            ]
      },
      "month": {
            "few": [
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies."
            ],
            "many": [
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies."
            ],
            "plural": [
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies."
            ],
            "singular": [
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies.",
                  "mies."
            ]
      },
      "second": {
            "few": [
                  "sekundy",
                  "sekund",
                  "sekundom",
                  "sekundy",
                  "sekundach",
                  "sekundami",
                  "sekundy"
            ],
            "many": [
                  "sekund",
                  "sekund",
                  "sekundom",
                  "sekund",
                  "sekundach",
                  "sekundami",
                  "sekund"
            ],
            "plural": [
                  "sekund",
                  "sekund",
                  "sekund",
                  "sekund",
                  "sekund",
                  "sekund",
                  "sekund"
            ],
            "singular": [
                  "sekunda",
                  "sekundy",
                  "sekundzie",
                  "sekundę",
                  "sekundzie",
                  "sekundą",
                  "sekundo"
            ]
      },
      "year": {
            "few": [
                  "lata",
                  "lat",
                  "latom",
                  "lata",
                  "latach",
                  "latami",
                  "lata"
            ],
            "many": [
                  "lat",
                  "lat",
                  "latom",
                  "lat",
                  "latach",
                  "latami",
                  "lat"
            ],
            "plural": [
                  "lat",
                  "lat",
                  "lat",
                  "lat",
                  "lat",
                  "lat",
                  "lat"
            ],
            "singular": [
                  "rok",
                  "roku",
                  "rokowi",
                  "rok",
                  "roku",
                  "rokiem",
                  "rok"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
